import { confidenceBand, DEFAULT_CONFIDENCE_THRESHOLDS } from '@grovus/design-system'
import type { ConfidenceBand, ConfidenceThresholds } from '@grovus/design-system'
import type { VerdictBasis } from './contract'

export type { ConfidenceBand, ConfidenceThresholds }
export { DEFAULT_CONFIDENCE_THRESHOLDS }

/**
 * Which band a conversion count falls in.
 *
 * It delegates to the design system so there is one classification behind the ticks, the
 * table, the parked group and the legend. A second copy here would be the same arithmetic
 * with its own thresholds, and the first time the two disagreed the screen would show a
 * creative parked under a mark saying it was reliable.
 *
 * The count is the reported one, even when `conversions` is incomplete: the band is a
 * floor, and a partial count cannot overstate it.
 */
export function reliabilityOf(
  conversions: number,
  thresholds: ConfidenceThresholds = DEFAULT_CONFIDENCE_THRESHOLDS,
): ConfidenceBand {
  return confidenceBand(conversions, thresholds)
}

/**
 * The thresholds a response was judged with: the company's tiers echoed in its
 * `verdictBasis` (GRO-186). A response without a basis reads as the defaults.
 */
export function thresholdsOf(basis: VerdictBasis | null | undefined): ConfidenceThresholds {
  if (!basis) return DEFAULT_CONFIDENCE_THRESHOLDS
  const { direction, provisional, reliable } = basis.tiers
  return { directionAt: direction, provisionalAt: provisional, reliableAt: reliable }
}
